const types = {
  SHOW_SNACKBAR: 'snackBar/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'snackBar/HIDE_SNACKBAR',
};

export default types;
